var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.309c5.352 0 9.691 4.338 9.691 9.69S17.352 21.69 12 21.69 2.31 17.351 2.31 12A9.69 9.69 0 0 1 12 2.309m0 1.199a8.492 8.492 0 1 0 0 16.983 8.492 8.492 0 0 0 0-16.983m0 4.354a.5.5 0 0 1 .5.5V11.5h3.136a.5.5 0 1 1 0 1H12.5v3.136a.5.5 0 0 1-1 0v-3.136H8.363a.5.5 0 0 1 0-1H11.5V8.362a.5.5 0 0 1 .5-.5"
  })));
};
export default SvgPlusCircle;